/**
 * @typedef {Object} Message
 * @property {string?} typeObject
 */

export const MESSAGE_OBJECT_TYPES = {
    AUDIO: "audio",
    TEXT: "text",
};

/**
 *
 * @param {Message} message
 * @param {string} type
 * @returns {boolean}
 */
export function messageIsObjectType(message, type) {
    if (message.typeObject == null || message.typeObject === "") {
        return type === MESSAGE_OBJECT_TYPES.TEXT;
    }
    return message.typeObject === type;
}

/**
 *
 * @param {Message} message
 * @returns {boolean}
 */
export function messageIsText(message) {
    return messageIsObjectType(message, MESSAGE_OBJECT_TYPES.TEXT);
}

/**
 *
 * @param {Message} message
 * @returns {boolean}
 */
export function messageIsAudio(message) {
    return messageIsObjectType(message, MESSAGE_OBJECT_TYPES.AUDIO);
}